import { Search } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { EcommerceHook } from 'slices/ecommerce/hook';

interface IProps {
  className?: string;
  selectedCategory: string;
  filterSearchData: (e: React.ChangeEvent<HTMLInputElement>) => void;
  setSelectedCategory: (value: string) => void;
  handleSearchClick: () => void;
}
const SearchProduct = (props: IProps) => {
  const { t } = useTranslation();
  const { search } = EcommerceHook();

  return (
    <div
      className={`relative sm:grow md:mx-16 lg:mx-28 w-full sm:w-auto ${props.className || ''}`}
    >
      <button
        type="button"
        className="inline-flex justify-center items-center w-10 h-8 rounded-sm bg-common absolute right-1 top-1 text-slate-500 fill-slate-100 cursor-pointer"
        onClick={props.handleSearchClick}
      >
        <Search className="size-4 stroke-slate-100" />
      </button>

      <select
        className="hidden absolute left-1 top-1 h-8 pl-2 pr-6 rounded text-sm bg-white border border-slate-200 text-slate-600 focus:outline-none"
        value={props.selectedCategory}
        onChange={(e) => props.setSelectedCategory(e.target.value)}
      >
        <option value="TAOBAO">Taobao</option>
        <option value="1688">1688</option>
      </select>

      <input
        type="text"
        className="pl-2 pr-8 search form-input border-slate-200 focus:outline-none h-10"
        placeholder={t('Search For')}
        autoComplete="off"
        value={search}
        onChange={props.filterSearchData}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            props.handleSearchClick();
          }
        }}
      />
    </div>
  );
};

export default SearchProduct;
